import React, { Component } from 'react';
import InputField from '../../../components/inputs/inputField';
import TextAreaField from '../../../components/inputs/textAreaField';
import FieldModal from '../../../components/modals/fieldModal';

class AddRegistrantModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			firstName: '',
			lastName: '',
			email: '',
			phoneNumber: '',
			company: '',
			notes: '',
			submitting: false,
			invalid: false,
			error: '',
			requiredFields: {
				email: false,
				firstName: false,
			}
		};
	}

	handleFNChange = (e) => {
		this.setState({
			firstName: e.target.value,
			requiredFields: {
				...this.state.requiredFields,
				firstName: false
			}
		});
	};

	handleLNChange = (e) => {
		this.setState({
			lastName: e.target.value
		});
	};

	handleEAChange = (e) => {
		const email = e.target.value;
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const isValidEmail = emailRegex.test(email);
	
		let error = '';
		let emailError = false;
	
		if (!email) {
			error = 'Required';
			emailError = true;
		} else if (!isValidEmail) {
			error = 'Invalid email format';
			emailError = true;
		}
	
		this.setState({
			email: email,
			requiredFields: {
				...this.state.requiredFields,
				email: emailError
			},
			error: error
		});
	};

	handlePhoneChange = (e) => {
		this.setState({
			phoneNumber: e.target.value
		});
	};

	handleCompanyChange = (e) => {
		this.setState({
			company: e.target.value
		});
	};

	handleNotesChange = (e) => {
		this.setState({
			notes: e.target.value
		});
	};

	addRegistrant = async () => {
		this.setState({ submitting: true });
		const { firstName, lastName, email, phoneNumber, company, notes } = this.state;
		const requiredFields = this.state.requiredFields;
		let valid = true;

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const isValidEmail = emailRegex.test(email);

		let payload = {
			firstName: firstName.trim(),
			lastName: lastName.trim(),
			email: email.trim().toLowerCase(),
			phoneNumber: phoneNumber.trim(),
			company: company.trim(),
			notes: notes.trim()
		};

		// Validate required fields
		Object.keys(requiredFields).forEach((key) => {
			if (!payload[key] || payload[key] === '') {
				requiredFields[key] = true;
				valid = false;
			} else {
				requiredFields[key] = false;
			}
		});

		// Additional email validation
		if (!email) {
			this.setState({
				requiredFields: { ...requiredFields, email: true },
				error: 'Required',
				submitting: false
			});
			valid = false;
		} else if (!isValidEmail) {
			this.setState({
				requiredFields: { ...requiredFields, email: true },
				error: 'Invalid email format',
				submitting: false
			});
			valid = false;
		}

		if (valid) {
			try {
				// Wait for the API call to complete
				await this.props.handleSubmit(payload);
				// Only reset and close modal after successful submission
				this.resetAdd(true);
			} catch (error) {
				// Handle API error
				console.error('Error adding registrant:', error);
				
				// Extract error message from the error object
				let errorMessage = 'Failed to add registrant. Please try again.';
				if (error.message) {
					errorMessage = error.message;
				}
				
				this.setState({ 
					submitting: false,
					error: errorMessage,
					requiredFields: { ...requiredFields, email: true }
				});
			}
		} else {
			this.setState({ submitting: false, requiredFields: requiredFields });
		}
	};

	resetAdd = (toggle) => {
		this.setState({
			firstName: '',
			lastName: '',
			email: '',
			phoneNumber: '',
			company: '',
			notes: '',
			submitting: false,
			invalid: false,
			error: '',
			requiredFields: {
				email: false,
				firstName: false,
			}
		});
		if (toggle) this.props.toggle();
	};

	render() {
		const { isOpen, toggle, style } = this.props;
		const {
			firstName,
			lastName,
			email,
			phoneNumber,
			company,
			notes,
			error,
			requiredFields
		} = this.state;

		return (
			<div>
				<FieldModal
					style={style}
					isOpen={isOpen}
					size={'medium'}
					modalTitle={"New Registrant"}
					bodyHeaderText={'Add a new registrant to your booking page. They will be able to submit booking requests.'}
					bodyContent={() => {
						return (
							<div>
								<h4 className='blockHeader mb-10'>Basic Information</h4>
								
								<InputField
									label="First Name"
									required={true}
									errorTrigger={requiredFields.firstName}
									value={firstName}
									onChange={this.handleFNChange} 
								/>
								
								<InputField
									label="Last Name"
									value={lastName}
									onChange={this.handleLNChange} 
								/>
								
								<InputField
									label="Email Address"
									required={true}
									errorMessage={error !== '' && error}
									errorTrigger={requiredFields.email}
									value={email}
									onChange={this.handleEAChange} 
								/>
								
								<InputField
									label="Phone Number"
									value={phoneNumber}
									onChange={this.handlePhoneChange} 
								/>
								
								<InputField
									label="Company"
									value={company}
									onChange={this.handleCompanyChange} 
								/>
								
								<TextAreaField
									label="Notes"
									value={notes}
									onChange={this.handleNotesChange}
									rows={3}
									placeholder="Add any notes about this registrant..."
								/>
							</div>
						)
					}}
					toggle={toggle}
					actionButtonLabel={this.state.submitting ? "Adding..." : "Add"}
					actionButton={() => this.addRegistrant()}
					actionButtonDisabled={this.state.submitting}
				/>
			</div>
		);
	}
}

export default AddRegistrantModal;
